import React from "react";
import { useState } from "react";
import {
  CssBaseline,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import Step1Casnic from "./Step1Casnic";
import Step2Casnic from "./Step2Casnic";
import Step3Casnic from "./Step3Casnic";
import Step4Casnic from "./Step4Casnic";
import Step5Casnic from "./Step5Casnic";
import Step6Casnic from "./Step6Casnic";
import Step7Casnic from "./Step7Casnic";
import Step8Casnic from "./Step8Casnic";
import Step9Casnic from "./Step9Casnic";
import "@fontsource/rubik/500.css";
import "@fontsource/rubik/400.css";

const theme = createTheme({
  typography: {
    fontFamily: "Rubik, sans-serif",
  },
});

const Casnic2 = () => {
  const [step, setStep] = useState(1);

  const isLaptop = useMediaQuery("(max-width: 1400px)");

  const isMobile = useMediaQuery("(max-width: 1024px)");

  const handleStep = (stepNo) => {
    setStep(stepNo);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={{ display: "grid", justifyItems: "center" }}>
        <Paper elevation={0} sx={{ width: isMobile ? "100%" : "60%" }}>
          <Typography
            variant="h5"
            sx={{
              mx: isMobile ? 4 : isLaptop? 20 : 23,
              mt: isMobile? 2: 10,
              mb: isMobile? 0 : 4,
              width: isMobile? '70%' : isLaptop? '70%' : "53%",
              fontWeight: "500",
            }}
          >
            Etapele pe care trebuie să le parcurgi pentru a te racorda la
            rețeaua de distribuție energie electrică
          </Typography>
          <Typography
            variant="h5"
            sx={{
              mx: isMobile ? 4 : isLaptop? 20: 23,
              mt: isMobile? 2: 0,
              mb: isMobile? 8: 6,
              color: "#29348f",
              fontWeight: "500",
            }}
          >
            Clienții casnici{" "}
          </Typography>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              position: "relative",
              transform: isMobile ? "rotate(90deg)" : "", // Rotate the div 90 degrees clockwise
              transformOrigin: isMobile ? "left" : "",
              marginLeft: isMobile ? 25 : "", // Set the rotation origin to the bottom
              "@media (minWidth: 600px)": {
                // Adjust the breakpoint based on your design
                transform: "none", // Reset the transform for larger screens
              },
            }}
          > 
            <div
              style={{
                position: "absolute",
                width: isMobile ? "120%" : "75%",
                height: "4px",
                backgroundColor: "#29348f",
                top: "47%",
              }}
            ></div>
            <IconButton
              onClick={() => handleStep(1)}
              onTouchStart={() => handleStep(1)}
              sx={{
                backgroundColor: step == 1 ? "#29348f" : "#858585",
                color: "white",
                width: "35px",
                height: "35px",
                ml: "5%",
                "&:hover": { backgroundColor: "#858585" },
              }}
            >
              {" "}
              <Typography sx={{ fontSize: 15, transform: isMobile ? "rotate(270deg)" : "", }}>1 </Typography>
            </IconButton>
            <IconButton
              onClick={() => handleStep(2)}
              onTouchStart={() => handleStep(2)}
              sx={{
                backgroundColor: step == 2 ? "#29348f" : "#858585",
                color: "white",
                width: "35px",
                height: "35px",
                ml: "5%",
                "&:hover": { backgroundColor: "#858585" },
              }}
            >
              {" "}
              <Typography sx={{ fontSize: 15, transform: isMobile ? "rotate(270deg)" : "", }}>2 </Typography>
            </IconButton>
            <IconButton
              onClick={() => handleStep(3)}
              onTouchStart={() => handleStep(3)}
              sx={{
                backgroundColor: step == 3 ? "#29348f" : "#858585",
                color: "white",
                width: "35px",
                height: "35px",
                ml: "5%",
                "&:hover": { backgroundColor: "#858585" },
              }}
            >
              {" "}
              <Typography sx={{ fontSize: 15, transform: isMobile ? "rotate(270deg)" : "", }}>3 </Typography>
            </IconButton>
            <IconButton
              onClick={() => handleStep(4)}
              onTouchStart={() => handleStep(4)}
              sx={{
                backgroundColor: step == 4 ? "#29348f" : "#858585",
                color: "white",
                width: "35px",
                height: "35px",
                ml: "5%",
                "&:hover": { backgroundColor: "#858585" },
              }}
            >
              {" "}
              <Typography sx={{ fontSize: 15, transform: isMobile ? "rotate(270deg)" : "", }}>4 </Typography>
            </IconButton>
            <IconButton
              onClick={() => handleStep(5)}
              onTouchStart={() => handleStep(5)}
              sx={{
                backgroundColor: step == 5 ? "#29348f" : "#858585",
                color: "white",
                width: "35px",
                height: "35px",
                ml: "5%",
                "&:hover": { backgroundColor: "#858585" },
              }}
            >
              {" "}
              <Typography sx={{ fontSize: 15, transform: isMobile ? "rotate(270deg)" : "", }}>5 </Typography>
            </IconButton>
            <IconButton
              onClick={() => handleStep(6)}
              onTouchStart={() => handleStep(6)}
              sx={{
                backgroundColor: step == 6 ? "#29348f" : "#858585",
                color: "white",
                width: "35px",
                height: "35px",
                ml: "5%",
                "&:hover": { backgroundColor: "#858585" },
              }}
            >
              {" "}
              <Typography sx={{ fontSize: 15, transform: isMobile ? "rotate(270deg)" : "", }}>6 </Typography>
            </IconButton>
            <IconButton
              onClick={() => handleStep(7)}
              onTouchStart={() => handleStep(7)}
              sx={{
                backgroundColor: step == 7 ? "#29348f" : "#858585",
                color: "white",
                width: "35px",
                height: "35px",
                ml: "5%",
                "&:hover": { backgroundColor: "#858585" },
              }}
            >
              {" "}
              <Typography sx={{ fontSize: 15, transform: isMobile ? "rotate(270deg)" : "", }}>7 </Typography>
            </IconButton>
            <IconButton
              onClick={() => handleStep(8)}
              onTouchStart={() => handleStep(8)}
              sx={{
                backgroundColor: step == 8 ? "#29348f" : "#858585",
                color: "white",
                width: "35px",
                height: "35px",
                ml: "5%",

                "&:hover": { backgroundColor: "#858585" },
              }}
            >
              <Typography sx={{ fontSize: 15, transform: isMobile ? "rotate(270deg)" : "", }}>8 </Typography>
            </IconButton>
            <IconButton
              onClick={() => handleStep(9)}
              onTouchStart={() => handleStep(9)}
              sx={{
                backgroundColor: step == 9 ? "#29348f" : "#858585",
                color: "white",
                width: "35px",
                height: "35px",
                ml: "5%",
                mr: "4%",
                "&:hover": { backgroundColor: "#858585" },
              }}
            >
              <Typography sx={{ fontSize: 15, transform: isMobile ? "rotate(270deg)" : "", }}>9 </Typography>
            </IconButton>
          </div>
          {isMobile? ('') : (<div
            style={{
              marginTop: isMobile? 1 : 15,
              position: isMobile? 'absolute' :'',
              width: isMobile? '130%' : '',
              top:'35.5%',
              left:'0%',
              transform: isMobile ? "rotate(90deg)" : "", // Rotate the div 90 degrees clockwise
              transformOrigin: isMobile ? "left" : "",
              "@media (minWidth: 600px)": {
                // Adjust the breakpoint based on your design
                transform: "none", // Reset the transform for larger screens
              },
            }}
          >
            <img
              src={require("../assets/pas1Icon.svg").default}
              style={{
                width: isLaptop ? 50 : isMobile? 35 : 60,
                height: isLaptop ? 50 : isMobile? 35 : 60,
                marginLeft: isLaptop ? "10%" : isMobile? '0%' : "16%",
                transform: isMobile ? "rotate(270deg)" : "", // Rotate the div 90 degrees clockwise
                transformOrigin: isMobile ? "left" : "",
               
                "@media (minWidth: 600px)": {
                  // Adjust the breakpoint based on your design
                  transform: "none", // Reset the transform for larger screens
                },
              }}
              alt="pas2icon"
            />

            <img
              src={require("../assets/pas2Icon.svg").default}
              style={{
                width: isLaptop ? 50 : isMobile? 35 : 60,
                height: isLaptop ? 50 : isMobile? 35 :60,
                marginLeft: isLaptop ? "4%" : isMobile? '4.5%' : "3%",
                transform: isMobile ? "rotate(270deg)" : "", // Rotate the div 90 degrees clockwise
                transformOrigin: isMobile ? "left" : "",
               
                "@media (minWidth: 600px)": {
                  // Adjust the breakpoint based on your design
                  transform: "none", // Reset the transform for larger screens
                },
              }}
              alt="pas2icon"
            />
            <img
              src={require("../assets/pas3Icon.svg").default}
              style={{
                width: isLaptop ? 50 : isMobile? 35 : 60,
                height: isLaptop ? 50 : isMobile? 35 :60,
                marginLeft:isMobile? '3.5%' : "2%",
                transform: isMobile ? "rotate(270deg)" : "", // Rotate the div 90 degrees clockwise
                transformOrigin: isMobile ? "left" : "",
               
                "@media (minWidth: 600px)": {
                  // Adjust the breakpoint based on your design
                  transform: "none", // Reset the transform for larger screens
                },
              }}
              alt="pas2icon"
            />

            <img
              src={require("../assets/pas4Icon.svg").default}
              style={{
                width: isLaptop ? 50 : isMobile? 35 :60,
                height: isLaptop ? 50 : isMobile? 35 : 60,
                marginLeft: isLaptop ? "3.5%" : isMobile? '4.2%' : "3%",
                transform: isMobile ? "rotate(270deg)" : "", // Rotate the div 90 degrees clockwise
                transformOrigin: isMobile ? "left" : "",
               
                "@media (minWidth: 600px)": {
                  // Adjust the breakpoint based on your design
                  transform: "none", // Reset the transform for larger screens
                },
              }}
              alt="pas2icon"
            />

            <img
              src={require("../assets/pas5Icon.svg").default}
              style={{
                width: isLaptop ? 50 : isMobile? 35 : 60,
                height: isLaptop ? 60 : isMobile? 35 : 70,
                marginLeft: isMobile? '3.5%' : "3%",
                transform: isMobile ? "rotate(270deg)" : "", // Rotate the div 90 degrees clockwise
                transformOrigin: isMobile ? "left" : "",
               
                "@media (minWidth: 600px)": {
                  // Adjust the breakpoint based on your design
                  transform: "none", // Reset the transform for larger screens
                },
              }}
              alt="pas2icon"
            />

            <img
              src={require("../assets/pas6Icon.svg").default}
              style={{
                width: isLaptop ? 50 : isMobile? 35 : 60,
                height: isLaptop ? 50 : isMobile? 35 : 60,
                marginLeft: isMobile? '4.5%' : "3%",
                transform: isMobile ? "rotate(270deg)" : "", // Rotate the div 90 degrees clockwise
                transformOrigin: isMobile ? "left" : "",
               
                "@media (minWidth: 600px)": {
                  // Adjust the breakpoint based on your design
                  transform: "none", // Reset the transform for larger screens
                },
              }}
              alt="pas2icon"
            />

            <img
              src={require("../assets/pas7Icon.svg").default}
              style={{
                width: isLaptop ? 50 : isMobile? 35 : 60,
                height: isLaptop ? 50 : isMobile? 35 : 60,
                marginLeft: isLaptop ? "3.5%" : isMobile? '4%' : "2.5%",
                transform: isMobile ? "rotate(270deg)" : "", // Rotate the div 90 degrees clockwise
                transformOrigin: isMobile ? "left" : "",
               
                "@media (minWidth: 600px)": {
                  // Adjust the breakpoint based on your design
                  transform: "none", // Reset the transform for larger screens
                },
              }}
              alt="pas2icon"
            />

            <img
              src={require("../assets/pas8Icon.svg").default}
              style={{
                width: isLaptop ? 50 : isMobile? 35 : 65,
                height: isLaptop ? 50 : isMobile? 35 :65,
                marginLeft: isLaptop ? "3.5%" : isMobile? '3.8%' :  "2.5%",
                transform: isMobile ? "rotate(270deg)" : "", // Rotate the div 90 degrees clockwise
                transformOrigin: isMobile ? "left" : "",
               
                "@media (minWidth: 600px)": {
                  // Adjust the breakpoint based on your design
                  transform: "none", // Reset the transform for larger screens
                },
              }}
              alt="pas2icon"
            />
            <img
              src={require("../assets/pas9Icon.svg").default}
              style={{
                width: isLaptop ? 50 : isMobile? 35 : 60,
                height: isLaptop ? 50 : isMobile? 35 : 60,
                marginLeft: isMobile? '3%' : "2.5%",
                marginRight: isMobile? '2%' : "4%",
                transform: isMobile ? "rotate(270deg)" : "", // Rotate the div 90 degrees clockwise
                transformOrigin: isMobile ? "left" : "",
               
                "@media (minWidth: 600px)": {
                  // Adjust the breakpoint based on your design
                  transform: "none", // Reset the transform for larger screens
                },
              }}
              alt="pas2icon"
            />
          </div>)}
        </Paper>
        <div style={{ width:isMobile? '75%' : "60%" }}>
          {step === 1 && <Step1Casnic />}
          {step === 2 && <Step2Casnic />}
          {step === 3 && <Step3Casnic />}
          {step === 4 && <Step4Casnic />}
          {step === 5 && <Step5Casnic />}
          {step === 6 && <Step6Casnic />}
          {step === 7 && <Step7Casnic />}
          {step === 8 && <Step8Casnic />}
          {step === 9 && <Step9Casnic />}
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Casnic2;
